import * as CommentTrashActionTypes from '../../../constants/comments/CommentTrashActionTypes';

const initialState = {
    items: [],
    totalCount: null
};

const itemUpdate = (items, id, values) => items.map(item => {
	if (item.id === id) {
		item = Object.assign({}, item, values)
	}
	return item
})

const updatedItems = (state, id, values) => Object.assign({}, state, {
	items: itemUpdate(state.items, id, values)
})

const selectedItems = (items, id, select) => items.map(item => {
    if (item.id === id) {
        item = Object.assign({}, item, { selected: select })
    }
    return item
});

export default (state = initialState, action) => {
	switch (action.type) {
		case CommentTrashActionTypes.CLEAR_ITEMS:
            return {
                items: [],
                totalCount: null,
            }
		case CommentTrashActionTypes.RECEIVE_ITEMS:
			return {
				items: action.items,
				totalCount: action.totalCount
			}
		case CommentTrashActionTypes.SELECT_ITEM:
			return updatedItems(state, action.id, { selected: true })

		case CommentTrashActionTypes.DESELECT_ITEM:
			return updatedItems(state, action.id, { selected: false })

		case CommentTrashActionTypes.SELECT_ALL_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => {
					if ( item.editable) {
                    	item = Object.assign({}, item, { selected: true })
                    }
					return item
				})
			})
		case CommentTrashActionTypes.DESELECT_ALL_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => Object.assign({}, item, { selected: false }) )
			})
		case CommentTrashActionTypes.UPDATE_ITEM:
			return updatedItems(state, action.item.id, action.item)

		case CommentTrashActionTypes.UPDATE_SELECTED_ITEMS:
			return Object.assign({}, state, {
				items: state.items.map(item => {
					if (item.selected) {
						item = Object.assign({}, item, action.values)
					}
					return item
				})
			})

	}
	return state
}
